import React from "react";
import { useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export const withToast = WrappedComponent => {
  return props => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const showSuccess = (message) => {
      enqueueSnackbar(message, { variant: "success" })
    };

    const showSuccessPerm = (message) => {
      enqueueSnackbar(message, {
        variant: "success",
        style: { whiteSpace: 'pre-line' },
        persist: true,
        action: key => (
          <IconButton aria-label="Close notification" onClick={() => closeSnackbar(key)} style={{color: "inherit"}} size="small">
            <CloseIcon />
          </IconButton>
        )
      })
    };

    const showError = (message) => {
      enqueueSnackbar(message, {
        variant: "error",
        style: { whiteSpace: 'pre-line' },
        persist: true,
        action: key => (
          <IconButton aria-label="Close notification" onClick={() => closeSnackbar(key)} style={{color: "inherit"}} size="small">
            <CloseIcon />
          </IconButton>
        )
      })
    };

    return (
      <WrappedComponent {...props} successToast={showSuccess} successToastPersist={showSuccessPerm} errorToast={showError} />
    );
  };
};
